import React from 'react'
import { inject, observer } from 'mobx-react'
import BoundaryList from './BoundaryList'
import ErrorForm from '../common/ErrorForm'
import { withTranslation } from 'react-i18next'

const BoundaryListBrowse = ({ boundaryList, savingBoundaries, t }) => {
  return (
    <>
      {boundaryList.error && (
        <div className='boundary-list-pane__error'>
          <ErrorForm item={boundaryList} />
        </div>
      )}
      <BoundaryList
        root={boundaryList.root}
        savingBoundaries={savingBoundaries}
        parentNode={boundaryList.root}
      />
    </>
  )
}

export default withTranslation()(inject('uiStore')(observer(BoundaryListBrowse)))
